import React, {Component} from 'react';

import Box from './Box';

import i18n from '../resources/i18n';

class Row extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const buttonTextBox = i18n.t('boxComponent.buttonText');
    const buttonTextClassBox = 'far fa-arrow-alt-circle-right';
    const buttonClassBox = 'button';

    const textMapaRapido = i18n.t('boxComponent.fastMapText');
    const titleMapaRapido = i18n.t('boxComponent.fastmapTitle');

    const textMapaElaborado = i18n.t('boxComponent.completeMapText');
    const titleMapaElaborado = i18n.t('boxComponent.completeMapTitle');

    const textMapaPoster = i18n.t('boxComponent.posterMapText');
    const titleMapaPoster = i18n.t('boxComponent.posterMapTitle');

    const textMapaFoto = i18n.t('boxComponent.photoMapText');
    const titleMapaFoto = i18n.t('boxComponent.photoMapTitle');

    const textMapaSerie = i18n.t('boxComponent.seriesMapText');
    const titleMapaSerie = i18n.t('boxComponent.seriesMapTitle');

    const linkMapaElaborado = '/DataForPrint';
    const linkMapaSimple = '/DataForPrint';
    const linkMapaPoster = '/DataForPrint';
    const linkMapaOthers = '/DataForPrint';
    return (<div className="row">
      <Box containtText={textMapaRapido} title={titleMapaRapido} buttonText={buttonTextBox} location={this.props.location} buttonTextClassBox={buttonTextClassBox} buttonclassName={buttonClassBox} routeLink={linkMapaSimple} setActive={4}/>
      <Box containtText={textMapaElaborado} title={titleMapaElaborado} buttonText={buttonTextBox} location={this.props.location} buttonTextClassBox={buttonTextClassBox} buttonclassName={buttonClassBox} routeLink={linkMapaElaborado} setActive={0}/>
      <Box containtText={textMapaPoster} title={titleMapaPoster} buttonText={buttonTextBox} location={this.props.location} buttonTextClassBox={buttonTextClassBox} buttonclassName={buttonClassBox} routeLink={linkMapaPoster} setActive={6}/>
      <Box containtText={textMapaFoto} title={titleMapaFoto} buttonText={buttonTextBox} location={this.props.location} buttonTextClassBox={buttonTextClassBox} buttonclassName={buttonClassBox} routeLink={linkMapaPoster} setActive={8}/>
      <Box containtText={textMapaSerie} title={titleMapaSerie} buttonText={buttonTextBox} location={this.props.location} buttonTextClassBox={buttonTextClassBox} buttonclassName={buttonClassBox} routeLink={linkMapaOthers} setActive={10}/>
    </div>);
  }
}

export default Row;
